import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="old-site-footer mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="/lovable-uploads/62e55e12-a6b7-4346-9c31-f9ad20c8b1b6.png" 
                alt="allunitcalculators.com logo" 
                className="h-20 w-auto max-w-none"
                style={{ height: '5rem', display: 'block' }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  console.log('Footer logo failed to load:', target.src);
                  target.style.backgroundColor = '#ff0000';
                  target.style.width = '200px';
                  target.style.height = '5rem';
                }}
                onLoad={() => console.log('Footer logo loaded successfully')}
              />
            </div>
            <p className="text-white/80 text-sm">
              Your one-stop solution for all calculation and unit conversion needs.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/calculators" className="font-bold text-white/80 hover:text-white transition-colors">
                  Calculators
                </Link>
              </li>
              <li>
                <Link to="/converters" className="font-bold text-white/80 hover:text-white transition-colors">
                  Converters
                </Link>
              </li>
              <li>
                <Link to="/blog" className="font-bold text-white/80 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4 text-white">About</h3>
            <p className="text-white/80 text-sm">
              allunitcalculators.com provides fast, accurate calculators and converters for everyday use.
            </p>
          </div>
        </div>
        <div className="border-t border-white/20 mt-8 pt-6">
          <p className="text-center text-white/70 text-xs">
            © {new Date().getFullYear()} allunitcalculators.com. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
